export default function PHP_strlen() {
  return (
    <div>
      <h1>PHP_strlen</h1>
    </div>
  );
}
